// extracted by mini-css-extract-plugin
module.exports = {"explanationChart":"styles_explanationChart__1mLp9","slideInFromRight":"styles_slideInFromRight__3sJ_u"};